import type { ZudokuConfig } from "zudoku";

const config: ZudokuConfig = {
  site: {
    // title: "The LivingOS Open API",
    logo: {
      src: {
        light: "/logos/los-logo-light.svg",
        dark: "/logos/los-logo-dark.svg",
      },
      alt: "The LivingOS",
      width: "130px",
    },
    // banner: {
    //   message: "Welcome to The LivingOS Open API!",
    //   color: "info", // "note" | "tip" | "info" | "caution" | "danger" or custom
    //   dismissible: false
    // }
    footer: {
      position: "center",
      columns: [
        {
          title: "Product",
          position: "start",
          links: [
            { label: "Home", href: "/index" },
            { label: "API Products", href: "/pms-intro" },
            { label: "PMS API (v3.0.1)", href: "/pms/v3.0.1" },
          ],
        },
        {
          title: "Resources",
          position: "center",
          links: [
            { label: "The LivingOS", href: "https://www.thelivingos.com/" },
            { label: "Urbanice", href: "https://urbanice.app/" },
          ],
        },
      ],
      social: [
        { icon: "facebook", href: "https://github.com/yourusername" },
        {
          icon: "youtube",
          href: "https://linkedin.com/company/yourcompany",
          label: "LinkedIn",
        },
      ],
      copyright: `© ${new Date().getFullYear()} The LivingOS Corporation ltd. All rights reserved.`,
      logo: {
        src: {
          light: "/logos/los-logo-light.svg",
          dark: "/logos/los-logo-dark.svg",
        },
        alt: "Company Logo",
        width: "60px",
      },
    },
  },
  authentication: {
    type: "auth0",
    domain: process.env.ZUDOKU_PUBLIC_AUTH0_DOMAIN || "",
    clientId: process.env.ZUDOKU_PUBLIC_AUTH0_CLIENT_ID || "",
    scopes: ["openid", "profile", "email"],
  },
  protectedRoutes: [
    "/documents", // Protects the Getting Started page
    "/api/*", // Protects the API Reference page
    "/admin/*", // Protects all admin pages (wildcard)
    "/pms-v12-1/*", // Protects the PMS API (12.1) page
  ],
  navigation: [
    {
      type: "link",
      to: "/index",
      label: "Home",
    },
    {
      type: "category",
      label: "API Products",
      items: [
        {
          type: "category",
          label: "PMS API",
          icon: "circle-dollar-sign",
          items: [
            {
              type: "link",
              icon: "book",
              label: "Introduction",
              to: "/pms-intro",
            },
            {
              type: "link",
              icon: "key",
              label: "Authentication & Authorization",
              to: "/auth",
            },
            {
              type: "link",
              label: "PMS Legacy API",
              icon: "database",
              to: "/api-pms-legacy",
            },
            {
              type: "link",
              icon: "folder-cog",
              badge: {
                label: "New",
                color: "purple",
              },
              label: "API Reference",
              to: "/api",
            },
          ],
        },
        {
          type: "category",
          label: "Urbanice",
          icon: "house",
          collapsible: true,
          items: [
            {
              type: "link",
              icon: "book",
              label: "Introduction",
              to: "/urb-intro",
            },
          ],
        },
        {
          type: "category",
          label: "GuardOS",
          icon: "shield-check",
          collapsible: true,
          items: [
            {
              type: "link",
              icon: "book",
              label: "Introduction",
              to: "/urb-intro",
            },
          ],
        },
      ],
    },
    {
      type: "link",
      to: "/pms",
      label: "PMS API",
    },
    {
      type: "link",
      to: "/myapps",
      label: "My Apps",
    },
  ],
  apis: [
    {
      type: "file",
      input: [
        "./apis/pms/openapi-v3.0.1.yaml",
        "./apis/pms/openapi-v3.0.0.yaml",
      ],
      path: "/pms",
      options: {
        examplesLanguage: "shell", // Default language for code examples
        disablePlayground: false, // Disable the interactive API playground
        disableSidecar: false, // Disable the sidecar completely
        showVersionSelect: "if-available", // Control version selector visibility
        expandAllTags: true, // Control initial expanded state of tag categories
      },
    },
  ],
   apiKeys: {
    enabled: true
  }
};

export default config;
